<script setup lang="ts">
import { computed } from 'vue';

export type CardType = 'default' | 'outline' | 'elevated' | 'ghost';

export interface CardProps {
	variant?: CardType;
	hoverable?: boolean;
	border?: boolean;
	fullWidth?: boolean;
}

const props = withDefaults(defineProps<CardProps>(), {
	variant: 'default',
	hoverable: false,
	border: true,
	fullWidth: true,
});

const variantClasses = computed(() => {
	return {
		default:
			'bg-gray-100 border-primary-light shadow-sm',

		outline:
			'bg-transparent border-primary-light',

		elevated:
			'bg-surface border-transparent shadow-xl shadow-black/5',

		ghost:
			'bg-surface-muted border-transparent',
	}[props.variant];
});

const hoverClasses = computed(() => {
	if (!props.hoverable) return '';

	return 'transition duration-200 hover:-translate-y-1 hover:shadow-2xl';
});
</script>

<template>
	<div :class="[
		'overflow-hidden border p-3 rounded-lg text-primary',
		variantClasses,
		hoverClasses,
		{
			'w-full': fullWidth,
			'border-0': !border,
		},
	]">
		<div v-if="$slots.header" class="mb-4">
			<slot name="header" />
		</div>

		<div v-if="$slots.media" class="-mx-5 -mt-5 mb-5 overflow-hidden">
			<slot name="media" />
		</div>

		<div class="flex-1">
			<slot />
		</div>

		<div v-if="$slots.footer" class="mt-5">
			<slot name="footer" />
		</div>
	</div>
</template>
